import { getBrandConfig } from '@axo/config';
import { Brand } from '@axo/config/@types/Brand.types';
import { Locale } from '@axo/config/@types/Locales.types';
import type { BrandVisual } from '@axo/ui-core/components/Brand';
import {
  Brand as BrandView,
  brandVisuals,
} from '@axo/ui-core/components/Brand';
import { Text } from '@axo/ui-core/components/typography';
import clsx from 'clsx';
import styles from './poweredBy.module.scss';

const labels: Record<Locale, string> = {
  'en-GB': 'Powered by {{brand}}',
  'da-DK': 'Drevet af {{brand}}',
  'fi-FI': '{{brand}} voimalla',
  'sv-SE': 'Drivs av {{brand}}',
  'nb-NO': 'Drevet av {{brand}}',
};

const getGenitiveFI = (name: string): string => {
  const lower = name.toLowerCase();
  if (lower.endsWith('us')) return name.slice(0, -2) + 'uksen'; // rahoitus → rahoituksen
  if (lower.endsWith('s')) return name + 'in'; // e.g. asus → asusin
  if (lower.endsWith('e')) return name + 'n'; // e.g. uscore → uscoren
  if (lower.endsWith('a')) return name.slice(0, -1) + 'an'; // e.g. axolaina → axolainan
  return name + 'n'; // default
};

export type PoweredByProps = {
  locale: Locale;
  brand: Brand;
  className?: string;
};

export const PoweredBy = ({ locale, brand, className }: PoweredByProps) => {
  const {
    name,
    theme: { brand: brandView },
  } = getBrandConfig(brand, ['site']).site!;

  const label = labels[locale].replace(
    '{{brand}}',
    locale === 'fi-FI' ? getGenitiveFI(name) : name
  );

  // in case the brand logo is white by default (freedom...)
  const darkVariant = `${brandView}--dark` as BrandVisual;
  const brandViewKey = brandVisuals.includes(darkVariant)
    ? darkVariant
    : brandView;

  return (
    <div className={clsx(styles.poweredBy, className)}>
      <Text className={styles.label}>
        <b>{label}</b>
      </Text>
      <BrandView brand={brandViewKey} className={styles.brand} />
    </div>
  );
};
